export function makeDynamicURL(url) {
  const query = location.href.indexOf("?");
  const hasQuery = query !== -1;
  const queryString = hasQuery ? location.href.substring(query) : "";
  return `${url}${queryString}`
}

export function goToDynamicURL(url) {
  location.assign(makeDynamicURL(url));
}